import { render, staticRenderFns } from "./LootDetailView.vue?vue&type=template&id=f8a3fa9c"
import script from "./LootDetailView.vue?vue&type=script&lang=js"
export * from "./LootDetailView.vue?vue&type=script&lang=js"
import style0 from "./LootDetailView.vue?vue&type=style&index=0&id=f8a3fa9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports